<template>
	<resource-list-item-skeleton title description image divided>

		<skeleton height="11" class="mb-2 mt-14" :width="80" rounded/>
	</resource-list-item-skeleton>
</template>

<script setup lang="ts">

</script>

